<template>
  <div>
    <Breadcrumbs main="" :title="PageTitle" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row second-chart-list">
        <div class="col-xl-12 box-col-12">
          <iframe
            v-if="CompanyLinks"
            :src="CompanyLinks"
            name="iframe_a"
            height="800px"
            width="100%"
            title="Fuel Cards"
            scrolling="no"
          ></iframe>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
  import Axios from "axios";
  export default {
    components: {},
    data() {
      return {
        CompanyLinks: [],
        IframeLink: "",
        PageTitle: "",
        Links: "",
        Type: "",
        PageName: "",
      };
    },
    mounted() {
      this.Type = this.$route.params.Type;
      this.PageName = this.$route.params.PageName;
      this.GetCompanyDetail();
    },
    methods: {
      GetCompanyDetail() {
        var CompanyData = JSON.parse(localStorage.getItem("Company"));
        if (CompanyData.fleet_settings_key != "") {
          this.CompanyLinks = JSON.parse(CompanyData.fleet_settings_key);
          this.Links = this.CompanyLinks.CompanyLinks;
          if (this.Type == "sidebar") {
            this.Links = this.CompanyLinks.ExternalLinks;
          }
          this.Links.forEach((data) => {
            if (this.createTitle(data.title) == this.PageName) {
              this.CompanyLinks = data.link;
              this.PageTitle = data.title;
              document.title = this.PageTitle;
            }
          });
        }
      },
      createTitle(title) {
        return title
          .replace(/(?!\w|\s)./g, "-")
          .replace(/\s+/g, "-")
          .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2")
          .toLowerCase();
      },
    },
  };
</script>
<style scoped>
  iframe {
    border: 0px;
  }
</style>
